import React from 'react'
import { useDispatch } from 'react-redux'
import Password from '../../../../icons/password.svg'
import Edit from '../../../../icons/edit.svg'
import { setConfirmationModal } from '../../../../redux/actions/confirmationModal'
import EditPassword from '../../../NestedComponents/Option 2/SettingsModals/EditPassword'

const Settings = () => {
  const dispatch = useDispatch()

  const handleEditClick = () => {
    dispatch(
      setConfirmationModal({
        headerText: 'Passwort ändern',
        body: <EditPassword />,
        large: true,
        headerBorder: true,
        modalFromSettings: true,
      }),
    )
  }

  return (
    <div>
      <div>
        <img src={Password} alt={Password} />
      </div>
      <div>
        <p>Aktuelles Passwort</p>
        <p>&#9210; &#9210; &#9210; &#9210; &#9210; &#9210;</p>
      </div>
      <div onClick={handleEditClick}>
        <img src={Edit} alt={Edit} />
      </div>
    </div>
  )
}

export default Settings
